import { Col, Row, Switch } from "antd";
import "./preferences.css";

export interface PreferencesProps {
  switchTheme: () => void;
  isChecked: boolean;
}

export const PreferencesPage = ({
  switchTheme,
  isChecked,
}: PreferencesProps) => {
  return (
    <div className="preferences">
      <Col>
        <Row>
          <Col span={24}>
            <p className="textOnPage">Switch theme (Light / Dark)</p>
          </Col>
        </Row>
        <Row>
          <Col span={24} className="switchButtonColumn">
            <Switch
              onChange={switchTheme}
              className="themeSwitchButton"
              checked={isChecked}
            />
          </Col>
        </Row>
      </Col>
    </div>
  );
};
